export const parametersCsvFields = [
  "orderId",
  "orderName",
  "returnCode",
  "createdAt",
  "orderedAt",
  "updatedAt",
  "shippedAt",
  "shippingAt",
  "treatedLogisticianAt",
  "treatedMerchantAt",
  "status",
] as const;

export const shippingCsvFields = [
  "shippingAddress1",
  "shippingAddress2",
  "shippingCity",
  "shippingZip",
  "shippingCountry",
  "shippingCountryCode",
  "shippingInfoCarrier",
  "shippingInfoTrackingCode",
  "customerId",
  "customerEmail",
  "customerFirstName",
  "customerLastName",
  "customerPhone",
  "lang",
] as const;

export const dataTreatmentCsvFields = [
  "logisticianValidated",
  "logisticianRejected",
  "logisticianReasonRejected",
  "merchantValidated",
  "merchantRejected",
  "merchantReasonRejected",
  "variantId",
  "quantity",
  "newVariantId",
  "newVariantBarcode",
  "locationId",
  "newOrderName",
] as const;

export const resultCsvFields = [
  "refunded",
  "discounted",
  "initialShippingRefund",
  "returnShippingPaid",
  "lineItemId",
  "sku",
  "title",
  "price",
  "reason",
  "productId",
  "quantityBought",
  "variantTitle",
  "variantBarcode",
  "resolution",
  "metafieldsVariant",
  "metafieldsProduct",
  "metafieldsOrder",
] as const;
